module.exports = __webpack_public_path__ + "static/media/planilha.982cec79.xlsx";